// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"b0261a38","77":"e34bc839","345":"fc981bde","718":"e309e26f","787":"be656661"}[chunkId] + ".chunk.js";
};